import React, { useEffect, useState } from "react";
import type { Socket } from "socket.io-client";
import { io } from "socket.io-client";
import { SocketContext } from "./socketContext";
import { API_URL } from "common/config";
import { useAuthStore } from "stores/authStore";

type Props = {
  children: React.ReactNode;
};

const getSocketConfig = (currentUserId: string) => ({
  query: { userId: currentUserId },
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

export const SocketProvider: React.FC<Props> = ({ children }) => {
  const currentUserId = useAuthStore(state => state.currentUserId);

  const [socket, setSocket] = useState<Socket | undefined>(undefined);
  const [socketUserId, setSocketUserId] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    if (!currentUserId) {
      if (socket) socket.disconnect();
      setSocket(undefined);
      setSocketUserId(undefined);
      return;
    }

    if (socket && socketUserId === currentUserId) return;

    if (socket) {
      socket.disconnect();
    }

    const nextSocket = io(API_URL, getSocketConfig(currentUserId));
    setSocket(nextSocket);
    setSocketUserId(currentUserId);

    return () => {
      nextSocket.disconnect();
    };
  }, [currentUserId]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
